import { HStack, Link, Text, VStack } from '@chakra-ui/react'
import { FiExternalLink } from 'react-icons/fi'

interface LegislatorResourceLinksProps {
  ballotpediaUrl: string | null
  voteSmartUrl: string | null
  openSecretsUrl: string | null
  followTheMoneyUrl: string | null
  variant?: 'stacked' | 'inline'
}

const LABELS: { key: keyof LegislatorResourceLinksProps; label: string }[] = [
  { key: 'ballotpediaUrl', label: 'Ballotpedia' },
  { key: 'voteSmartUrl', label: 'VoteSmart' },
  { key: 'openSecretsUrl', label: 'OpenSecrets' },
  { key: 'followTheMoneyUrl', label: 'FollowTheMoney' },
]

/** Slice-3 Tier B: link out to the exact crosswalk resources ingested with the legislator (Slice 1).
 *  Renders only present links; nothing when the legislator has none. Touch-friendly rows (mobile packet). */
export function LegislatorResourceLinks(props: LegislatorResourceLinksProps) {
  const { variant = 'stacked' } = props
  const links = LABELS.filter(({ key }) => props[key])
  if (links.length === 0) return null

  if (variant === 'inline') {
    return (
      <HStack gap={3} flexWrap="wrap">
        {links.map(({ key, label }) => (
          <Link key={key} href={props[key] as string} target="_blank" rel="noopener noreferrer"
                fontSize="sm" gap={1} alignItems="center">
            {label} <FiExternalLink aria-hidden />
          </Link>
        ))}
      </HStack>
    )
  }

  return (
    <VStack align="stretch" gap={2} mt={3}>
      <Text fontSize="xs" fontWeight="medium" color="fg.muted">Resources</Text>
      {links.map(({ key, label }) => (
        <Link key={key} href={props[key] as string} target="_blank" rel="noopener noreferrer"
              fontSize="sm" gap={1} minH="44px" alignItems="center">
          <HStack gap={1}>{label} <FiExternalLink aria-hidden /></HStack>
        </Link>
      ))}
    </VStack>
  )
}
